import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Form, Formik, FormikHelpers } from "formik";
import { validatorFactory, ValidatorType } from "../../utils/form/validators";
import FormInput from "../../utils/form/FormInput";
import { useNavigate } from 'react-router-dom';
import { backendURL, useApiFetch } from "../../utils/api";
import { useAuth } from "../../contexts/AuthContext";
import { useNotifications } from "../../contexts/NotificationContext";

function SignIn() {
    const { login } = useAuth();
    const navigate = useNavigate();
    const { success } = useNotifications();
    const apiFetch = useApiFetch();

    interface ValidationErrors {
        email?: string[];
        password?: string[];
    }

    interface FormValues {
        email: string;
        password: string;
    }

    const initialValues: FormValues = {
        email: "",
        password: ""
    };

    function validate(values: FormValues): ValidationErrors {
        const errors: ValidationErrors = {};

        const emailErrors = validatorFactory(values.email, ValidatorType.EMAIL);
        if (emailErrors.length > 0) {
            errors.email = emailErrors;
        }

        const passwordErrors = validatorFactory(values.password, ValidatorType.PASSWORD);
        if (passwordErrors.length > 0) {
            errors.password = passwordErrors;
        }

        return errors;
    }

    const handleSubmit = async (
        values: FormValues,
        { setSubmitting, setFieldValue }: FormikHelpers<FormValues>): Promise<void> => {
        try {
            const data = await apiFetch(`${backendURL}/auth/authenticate`, {
                method: "POST",
                body: JSON.stringify({
                    email: values.email,
                    password: values.password
                })
            });

            const token = data?.accessToken;
            const accountId = data?.accountId;
            login(token.startsWith("Bearer") ? token : `Bearer ${token}`, accountId);
            success("Zalogowano pomyślnie");
            navigate("/");
        } catch (err) {
            setFieldValue("password", "", false);
            setSubmitting(false);
        }
    }

    return (
        <Container>
            <Row>
                <Col xl={8} md={10} xs={12} className="mx-auto">
                    <div className="py-3">
                        <h1 className="font-weight-light text-center mb-4">Zaloguj się</h1>
                        <Formik<FormValues>
                            initialValues={initialValues}
                            validate={validate}
                            onSubmit={(values, helpers) => handleSubmit(values, helpers)}>

                            <Form className={"row"}>
                                <FormInput name="email" placeholder="Email" type="text" className="col-12"
                                    errorClassname="text-danger mt-1" />
                                <FormInput name="password" placeholder="Hasło" type="password" className="col-12 mt-4"
                                    errorClassname="text-danger mt-1" />

                                <div className="col-12 d-flex justify-content-center mt-4">
                                    <button className="btn btn-dark btn-block dim" type="submit">
                                        Zaloguj się
                                    </button>
                                </div>

                                <div className="col-12 d-flex justify-content-center mt-1">
                                    <button className="btn btn-dark btn-block dim" type="button" onClick={() => navigate('/')}>
                                        Zresetuj hasło
                                    </button>
                                </div>
                            </Form>
                        </Formik>
                    </div>
                </Col>
            </Row>
        </Container>
    )
}

export default SignIn;